import Card from "./Card.js";

const ProjectContainer = ({ projects, theme }) => {
  const projectCards = projects.map((project) => {
    return (
      <Card
        className="project-cards"
        id={project.id}
        key={project.id}
        name={project.name}
        description={project.description}
        preview={project.preview}
        videoPreview={project.videoPreview}
        githubLink={project.githubLink}
        liveLink={project.liveLink}
        supportLink={project.supportLink}
        theme={theme}
      />
    );
  });

  return <div className="my-project-container">{projectCards}</div>;
};

export default ProjectContainer;
